import * as React from 'react';
import { HeaderElements } from "../../HeaderElements/HeaderElements";
export var Datenschutz = function () {
  return /*#__PURE__*/React.createElement("div", {
    className: "prodwidth center gridreplace infopage l-container h-center c-infopage"
  }, /*#__PURE__*/React.createElement(HeaderElements, {
    title: "Datenschutz",
    description: ""
  }), /*#__PURE__*/React.createElement("span", {
    dangerouslySetInnerHTML: {
      __html: window.legal.privacy
    }
  }), /*#__PURE__*/React.createElement("br", null));
};
export default Datenschutz;